"use client";
import {
  ScrollArea,
  ScrollBar
} from "./chunk-CXL4IBKD.js";
import {
  getIconByFilename
} from "./chunk-QIHPKNID.js";
import {
  Button
} from "./chunk-24TR2GH3.js";

// src/code-block.tsx
import { cn } from "@momo/utils";
import { CheckIcon, CopyIcon } from "lucide-react";
import mergeRefs from "merge-refs";
import { useEffect, useRef, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var CodeBlock = (props) => {
  const { children, className, title, "data-lang": lang, figureClassName, ref, ...rest } = props;
  const textInput = useRef(null);
  const Icon = getIconByFilename(lang ?? "");
  const onCopy = () => {
    void navigator.clipboard.writeText(textInput.current?.textContent ?? "");
  };
  return /* @__PURE__ */ jsxs(
    "figure",
    {
      className: cn(
        "not-prose bg-secondary/50 group relative my-6 overflow-hidden rounded-lg border text-sm",
        figureClassName
      ),
      children: [
        title ? /* @__PURE__ */ jsxs("div", { className: "bg-muted/50 flex flex-row items-center gap-2 border-b px-4 py-1.5", children: [
          /* @__PURE__ */ jsx("div", { className: "text-muted-foreground", children: /* @__PURE__ */ jsx(Icon, { className: "size-3.5" }) }),
          /* @__PURE__ */ jsx("figcaption", { className: "text-muted-foreground flex-1 truncate", children: title }),
          /* @__PURE__ */ jsx(CopyButton, { onCopy })
        ] }) : /* @__PURE__ */ jsx(CopyButton, { className: "absolute right-4 top-3 z-10", onCopy }),
        /* @__PURE__ */ jsxs(ScrollArea, { children: [
          /* @__PURE__ */ jsx("pre", { ref: mergeRefs(textInput, ref), className: cn("p-4", className), ...rest, children }),
          /* @__PURE__ */ jsx(ScrollBar, { orientation: "horizontal" })
        ] })
      ]
    }
  );
};
var CopyButton = (props) => {
  const { onCopy, className, ...rest } = props;
  const [isCopied, setIsCopied] = useState(false);
  useEffect(() => {
    const copyResetTimeoutId = setTimeout(() => {
      setIsCopied(false);
    }, 2e3);
    return () => {
      clearTimeout(copyResetTimeoutId);
    };
  }, [isCopied]);
  return /* @__PURE__ */ jsx(
    Button,
    {
      className: cn("size-8 p-0 opacity-0 transition-opacity group-hover:opacity-100", className),
      variant: "outline",
      onClick: () => {
        onCopy();
        setIsCopied(true);
      },
      "aria-label": "Copy code to clipboard",
      ...rest,
      children: isCopied ? /* @__PURE__ */ jsx(CheckIcon, { className: "size-4" }) : /* @__PURE__ */ jsx(CopyIcon, { className: "size-4" })
    }
  );
};

export {
  CodeBlock
};
